import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

export async function deleteEventVault(eventVaultId: number) {
  const endpoint = `api/event/${eventVaultId}`

  await axios.delete(endpoint)
}

const DELETE_EVENT_VAULT_KEY = "deleteEventVault"

export function useDeleteEventVault() {
  return useMutation({
    mutationKey: [DELETE_EVENT_VAULT_KEY],
    mutationFn: (eventVaultId: number) => deleteEventVault(eventVaultId),
  })
}
